// A payment link's currency as shown: its code, or the customer's choice.
export const linkCurrencyLabel = (currency: string | undefined, t: (key: string) => string) =>
  currency === "customer_choice" ? t("Let customer choose") : String(currency || "").toUpperCase();
